export const CHANGEMODALSTATUS = 'changeModalStatus'
export const INIT_MARKER_LIST = 'initMarkerList'
export const INIT_MAP_HELPER = 'initMapHelper'


// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js